import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M15.82 7.5c0 2.11-1.71 3.82-3.82 3.82S8.18 9.61 8.18 7.5 9.89 3.68 12 3.68s3.82 1.71 3.82 3.82ZM4.5 18.487c0-1.235 1.072-2.279 2.71-3.044 1.6-.748 3.529-1.123 4.79-1.123 1.261 0 3.19.375 4.79 1.123 1.638.765 2.71 1.809 2.71 3.044v1.833h-15v-1.833Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "profile"}) } }